// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Inter font */

/* Reset and base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.landing-page {
  min-height: 100vh;
  background: #0A0A1B; /* Preserved original background */
  color: white;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  line-height: 1.6;
  overflow-x: hidden;
}

/* Hero Title at Top */
.hero-title-top {
  text-align: center;
  padding: 4rem 2rem 2rem;
}

.hero-title-top h1 {
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 0 0 1.5rem 0;
}

/* Special gradient for main hero title */
.purple-gradient-text {
  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.animated-title {
  animation: fadeInUp 0.8s ease-out both;
}

.hero-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin: 0 auto;
  font-weight: 400;
  position: relative;
  z-index: 1;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: 600;
  max-width: 600px;
  line-height: 1.6;
  animation: fadeInUp 0.8s ease-out 0.3s both;
}

/* Hero Section */
.hero-section {
  min-height: 60vh;
  display: flex;
  align-items: center;
  padding: 2rem 0;
}

.hero-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Hero Video Container */
.hero-video-container {
  display: flex;
  justify-content: center;
  animation: fadeInUp 0.8s ease-out 0.2s both;
  width: 100%;
}

/* Hero Landing Video */
.hero-landing-video {
  width: 100%;
  max-width: 900px;
  height: auto;
  min-height: 450px;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.hero-video-placeholder {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  width: 100%;
  max-width: 600px;
  aspect-ratio: 16/9;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.video-placeholder-content {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.hero-video-placeholder:hover .video-placeholder-content {
  background: rgba(0, 0, 0, 0.2);
}

.video-placeholder-content p {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  text-align: center;
}

.hero-content {
  animation: fadeInUp 0.8s ease-out;
}

.hero-highlight {
  color: white;
  position: relative;
}

.hero-highlight::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.3) 100%);
  animation: slideIn 1s ease-out 0.5s both;
}

/* Hero Video */
.hero-video {
  display: flex;
  justify-content: center;
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

.video-placeholder {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.main-demo {
  width: 100%;
  max-width: 500px;
  aspect-ratio: 16/10;
}

.video-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.video-placeholder:hover .video-overlay {
  background: rgba(0, 0, 0, 0.2);
}

.play-button {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.9);
  color: #0A0A1B;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  margin-bottom: 1rem;
  transition: all 0.3s ease;
  cursor: pointer;
}

.play-button:hover {
  transform: scale(1.1);
  background: white;
}

.video-overlay p {
  color: white;
  font-weight: 500;
  text-align: center;
}

/* Showcase Section */
.showcase-section {
  padding: 6rem 0;
  background: #0A0A1B;
}

.showcase-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.showcase-title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  text-align: center;
  margin-bottom: 4rem;
  letter-spacing: -0.02em;
}

.showcase-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 3rem;
}

.showcase-item {
  text-align: center;
  animation: fadeInUp 0.6s ease-out;
}

.feature-demo {
  width: 100%;
  max-width: 300px;
  aspect-ratio: 16/10;
  margin: 0 auto 1.5rem;
}

.play-button-small {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.9);
  color: #0A0A1B;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  cursor: pointer;
}

.play-button-small:hover {
  transform: scale(1.1);
  background: white;
}

.showcase-item h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: white;
}

.showcase-item p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  line-height: 1.6;
}

/* Trusted Section */
.trusted-section {
  padding: 4rem 0;
}

.trusted-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  text-align: center;
}

.trusted-title {
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 600;
  margin-bottom: 3rem;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: -0.02em;
}

.university-logos {
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
  position: relative;
}

.university-logos::before,
.university-logos::after {
  content: '';
  position: absolute;
  top: 0;
  width: 100px;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}

.university-logos::before {
  left: 0;
  background: linear-gradient(to right, #0A0A1B, rgba(10, 10, 27, 0));
}

.university-logos::after {
  right: 0;
  background: linear-gradient(to left, #0A0A1B, rgba(10, 10, 27, 0));
}

.university-logos-track {
  display: flex;
  align-items: center;
  gap: 2rem;
  animation: scroll-left 20s linear infinite;
  white-space: nowrap;
}

.university-logo {
  padding: 1rem 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.02);
  min-width: 120px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.university-logo:hover {
  border-color: rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.05);
  transform: translateY(-2px);
}

.logo-text {
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s ease;
}

.university-logo:hover .logo-text {
  color: rgba(255, 255, 255, 0.9);
}

/* Footer */
.footer-section {
  padding: 3rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  text-align: center;
}

.footer-container p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-container {
    padding: 0 1rem;
  }
  
  .hero-landing-video {
    max-width: 100%;
    border-radius: 12px;
  }

  .hero-video {
    margin: 0 1rem;
  }

  .showcase-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .university-logos {
    gap: 1rem;
  }

  .landing-page {
    padding: 0;
  }

  .hero-section,
  .showcase-section,
  .trusted-section {
    padding: 3rem 0;
  }
}

@media (max-width: 480px) {
  .hero-container,
  .showcase-container,
  .trusted-container,
  .footer-container {
    padding: 0 1rem;
  }

  .university-logos {
    gap: 0.5rem;
  }
  
  .hero-landing-video {
    border-radius: 8px;
  }
}

/* Features Section - Duolingo Style */
.features-section {
  padding: 8rem 0;
  background: #0A0A1B;
}

.features-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.feature-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  margin-bottom: 8rem;
  animation: fadeInUp 0.8s ease-out;
}

.feature-row:last-child {
  margin-bottom: 0;
}

.feature-content {
  padding: 2rem 0;
}

.feature-content h2 {
  font-size: clamp(2rem, 4vw, 2.8rem);
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: white;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.feature-content p {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  font-weight: 400;
  position: relative;
  z-index: 1;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.6;
}

.feature-video {
  display: flex;
  justify-content: center;
  align-items: center;
}

.feature-demo-video {
  width: 100%;
  max-width: 480px;
  height: auto;
  border-radius: 20px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Responsive Design for Features */
@media (max-width: 968px) {
  .feature-row {
    grid-template-columns: 1fr;
    gap: 3rem;
    text-align: center;
    margin-bottom: 6rem;
  }
  
  .feature-demo-video {
    max-width: 400px;
  }
  
  .features-section {
    padding: 6rem 0;
  }
}

@media (max-width: 768px) {
  .features-container {
    padding: 0 1rem;
  }
  
  .feature-row {
    gap: 2rem;
    margin-bottom: 4rem;
  }
  
  .feature-demo-video {
    max-width: 100%;
    border-radius: 16px;
  }
  
  .features-section {
    padding: 4rem 0;
  }
}

/* Showcase Section - Keep for backward compatibility but hide */
.showcase-section {
  display: none;
}

`, "",{"version":3,"sources":["webpack://./src/components/LandingPage.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAGtB,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB,EAAE,kCAAkC;EACvD,YAAY;EACZ,+EAA+E;EAC/E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gHAAgH;EAChH,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,2CAA2C;EAC3C,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,wFAAwF;EACxF,wCAAwC;AAC1C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,mEAAmE;AACrE;;AAEA;EACE,QAAQ;EACR,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,WAAW;AACX;EACE,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE;;;;IAIE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gHAAgH;EAChH,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA,mCAAmC;AACnC;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,gEAAgE;AAChE;EACE,aAAa;AACf","sourcesContent":["/* Import Inter font */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n/* Reset and base styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.landing-page {\n  min-height: 100vh;\n  background: #0A0A1B; /* Preserved original background */\n  color: white;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  line-height: 1.6;\n  overflow-x: hidden;\n}\n\n/* Hero Title at Top */\n.hero-title-top {\n  text-align: center;\n  padding: 4rem 2rem 2rem;\n}\n\n.hero-title-top h1 {\n  font-size: clamp(2.5rem, 5vw, 4rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  margin: 0 0 1.5rem 0;\n}\n\n/* Special gradient for main hero title */\n.purple-gradient-text {\n  background: linear-gradient(135deg, #7b3dd8 0%, #5707ab 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.animated-title {\n  animation: fadeInUp 0.8s ease-out both;\n}\n\n.hero-subtitle {\n  font-size: 1.2rem;\n  color: rgba(255, 255, 255, 0.8);\n  margin: 0 auto;\n  font-weight: 400;\n  position: relative;\n  z-index: 1;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  font-size: 0.9rem;\n  font-weight: 600;\n  max-width: 600px;\n  line-height: 1.6;\n  animation: fadeInUp 0.8s ease-out 0.3s both;\n}\n\n/* Hero Section */\n.hero-section {\n  min-height: 60vh;\n  display: flex;\n  align-items: center;\n  padding: 2rem 0;\n}\n\n.hero-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Hero Video Container */\n.hero-video-container {\n  display: flex;\n  justify-content: center;\n  animation: fadeInUp 0.8s ease-out 0.2s both;\n  width: 100%;\n}\n\n/* Hero Landing Video */\n.hero-landing-video {\n  width: 100%;\n  max-width: 900px;\n  height: auto;\n  min-height: 450px;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.hero-video-placeholder {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  width: 100%;\n  max-width: 600px;\n  aspect-ratio: 16/9;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.video-placeholder-content {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n}\n\n.hero-video-placeholder:hover .video-placeholder-content {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.video-placeholder-content p {\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 500;\n  text-align: center;\n}\n\n.hero-content {\n  animation: fadeInUp 0.8s ease-out;\n}\n\n.hero-highlight {\n  color: white;\n  position: relative;\n}\n\n.hero-highlight::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.3) 100%);\n  animation: slideIn 1s ease-out 0.5s both;\n}\n\n/* Hero Video */\n.hero-video {\n  display: flex;\n  justify-content: center;\n  animation: fadeInUp 0.8s ease-out 0.2s both;\n}\n\n.video-placeholder {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.main-demo {\n  width: 100%;\n  max-width: 500px;\n  aspect-ratio: 16/10;\n}\n\n.video-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n}\n\n.video-placeholder:hover .video-overlay {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.play-button {\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #0A0A1B;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  margin-bottom: 1rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.play-button:hover {\n  transform: scale(1.1);\n  background: white;\n}\n\n.video-overlay p {\n  color: white;\n  font-weight: 500;\n  text-align: center;\n}\n\n/* Showcase Section */\n.showcase-section {\n  padding: 6rem 0;\n  background: #0A0A1B;\n}\n\n.showcase-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.showcase-title {\n  font-size: clamp(2rem, 4vw, 3rem);\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 4rem;\n  letter-spacing: -0.02em;\n}\n\n.showcase-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 3rem;\n}\n\n.showcase-item {\n  text-align: center;\n  animation: fadeInUp 0.6s ease-out;\n}\n\n.feature-demo {\n  width: 100%;\n  max-width: 300px;\n  aspect-ratio: 16/10;\n  margin: 0 auto 1.5rem;\n}\n\n.play-button-small {\n  width: 50px;\n  height: 50px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #0A0A1B;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.play-button-small:hover {\n  transform: scale(1.1);\n  background: white;\n}\n\n.showcase-item h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: white;\n}\n\n.showcase-item p {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n/* Trusted Section */\n.trusted-section {\n  padding: 4rem 0;\n}\n\n.trusted-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  text-align: center;\n}\n\n.trusted-title {\n  font-size: clamp(1.5rem, 3vw, 2rem);\n  font-weight: 600;\n  margin-bottom: 3rem;\n  color: rgba(255, 255, 255, 0.9);\n  letter-spacing: -0.02em;\n}\n\n.university-logos {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  width: 100%;\n  position: relative;\n}\n\n.university-logos::before,\n.university-logos::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  width: 100px;\n  height: 100%;\n  z-index: 2;\n  pointer-events: none;\n}\n\n.university-logos::before {\n  left: 0;\n  background: linear-gradient(to right, #0A0A1B, rgba(10, 10, 27, 0));\n}\n\n.university-logos::after {\n  right: 0;\n  background: linear-gradient(to left, #0A0A1B, rgba(10, 10, 27, 0));\n}\n\n.university-logos-track {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  animation: scroll-left 20s linear infinite;\n  white-space: nowrap;\n}\n\n.university-logo {\n  padding: 1rem 1.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 0.02);\n  min-width: 120px;\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n.university-logo:hover {\n  border-color: rgba(255, 255, 255, 0.3);\n  background: rgba(255, 255, 255, 0.05);\n  transform: translateY(-2px);\n}\n\n.logo-text {\n  font-size: 0.9rem;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  color: rgba(255, 255, 255, 0.7);\n  transition: all 0.3s ease;\n}\n\n.university-logo:hover .logo-text {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Footer */\n.footer-section {\n  padding: 3rem 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.footer-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  text-align: center;\n}\n\n.footer-container p {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.9rem;\n}\n\n/* Animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideIn {\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n}\n\n@keyframes scroll-left {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .hero-container {\n    padding: 0 1rem;\n  }\n  \n  .hero-landing-video {\n    max-width: 100%;\n    border-radius: 12px;\n  }\n\n  .hero-video {\n    margin: 0 1rem;\n  }\n\n  .showcase-grid {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n\n  .university-logos {\n    gap: 1rem;\n  }\n\n  .landing-page {\n    padding: 0;\n  }\n\n  .hero-section,\n  .showcase-section,\n  .trusted-section {\n    padding: 3rem 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-container,\n  .showcase-container,\n  .trusted-container,\n  .footer-container {\n    padding: 0 1rem;\n  }\n\n  .university-logos {\n    gap: 0.5rem;\n  }\n  \n  .hero-landing-video {\n    border-radius: 8px;\n  }\n}\n\n/* Features Section - Duolingo Style */\n.features-section {\n  padding: 8rem 0;\n  background: #0A0A1B;\n}\n\n.features-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.feature-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4rem;\n  align-items: center;\n  margin-bottom: 8rem;\n  animation: fadeInUp 0.8s ease-out;\n}\n\n.feature-row:last-child {\n  margin-bottom: 0;\n}\n\n.feature-content {\n  padding: 2rem 0;\n}\n\n.feature-content h2 {\n  font-size: clamp(2rem, 4vw, 2.8rem);\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  color: white;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.feature-content p {\n  font-size: 1.2rem;\n  color: rgba(255, 255, 255, 0.8);\n  margin: 0;\n  font-weight: 400;\n  position: relative;\n  z-index: 1;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  font-size: 0.9rem;\n  font-weight: 600;\n  line-height: 1.6;\n}\n\n.feature-video {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.feature-demo-video {\n  width: 100%;\n  max-width: 480px;\n  height: auto;\n  border-radius: 20px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Responsive Design for Features */\n@media (max-width: 968px) {\n  .feature-row {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n    text-align: center;\n    margin-bottom: 6rem;\n  }\n  \n  .feature-demo-video {\n    max-width: 400px;\n  }\n  \n  .features-section {\n    padding: 6rem 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .features-container {\n    padding: 0 1rem;\n  }\n  \n  .feature-row {\n    gap: 2rem;\n    margin-bottom: 4rem;\n  }\n  \n  .feature-demo-video {\n    max-width: 100%;\n    border-radius: 16px;\n  }\n  \n  .features-section {\n    padding: 4rem 0;\n  }\n}\n\n/* Showcase Section - Keep for backward compatibility but hide */\n.showcase-section {\n  display: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
